import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "onChange", "disabled", "title", "subtitle", "error", "errorMessage", "className", "size", "inputElProps"];
import { clsx } from 'clsx';
import RadioButtonOn from '@crehana/compass.icons.fill/RadioButtonOn';
import RadioButtonOff from '@crehana/compass.icons.outline/RadioButtonOff';
import { getRadioColors } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Radio = function Radio(_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    title = _ref.title,
    subtitle = _ref.subtitle,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    inputElProps = _ref.inputElProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // The icons get its colors from the text property inherited from its parent
  var radioIconColors = getRadioColors(disabled, checked, errorMessage, error);
  return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread({
    className: clsx('tw-inline-flex tw-items-center tw-justify-center tw-relative', 'tw-gap-1.2', disabled ? 'tw-pointer-events-none' : 'tw-cursor-pointer', radioIconColors, className)
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, inputElProps), {}, {
      className: "tw-opacity-0 tw-absolute tw-inset-0",
      style: {
        zIndex: '-1'
      },
      type: "checkbox",
      disabled: disabled,
      onChange: onChange
    })), checked && !disabled ? /*#__PURE__*/_jsx(RadioButtonOn, {
      className: clsx('tw-h-2.4 tw-w-2.4 tw-min-h-[2.4rem] tw-min-w-[2.4rem]', 'tw-cursor-pointer tw-transition-colors')
    }) : /*#__PURE__*/_jsx(RadioButtonOff, {
      className: clsx('tw-h-2.4 tw-w-2.4 tw-min-h-[2.4rem] tw-min-w-[2.4rem]', 'tw-transition-colors')
    }), title && (title || subtitle || errorMessage) && /*#__PURE__*/_jsxs("span", {
      className: "tw-inline-grid",
      children: [title && /*#__PURE__*/_jsx("span", {
        className: clsx(size === 'm' ? 'tw-font-subtitle5' : 'tw-font-caption', disabled ? 'tw-text-neutral-light-500' : 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100'),
        children: title
      }), subtitle && size === 'm' && /*#__PURE__*/_jsx("span", {
        className: clsx('tw-font-body5', disabled ? 'tw-text-neutral-light-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500'),
        children: subtitle
      }), errorMessage && /*#__PURE__*/_jsx("span", {
        className: clsx('tw-font-caption', disabled ? 'tw-text-neutral-light-500' : 'tw-text-alert-500'),
        children: errorMessage
      })]
    })]
  }));
};
export default Radio;